<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
  <div class="row">
    <div class="col-sm" style="height: 10px;"></div>
    <div class="col-md" style="height: 20px"></div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb" class="bread-styles">
          <ol class="breadcrumb bd-background">
            <li class="breadcrumb-item active" aria-current="page">
              <a href="dashboardmain-admin" style="color: black;"> > Change Password</a>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-sm" style="height: 10px;"></div>
      <div class="col-md" style="height: 20px"></div>
    </div>
 
    <div class="pie-charts">
      <h4 style="text-align: center;"> CHANGE PASSWORD </h4>
      <hr>

      <form role="form" class="form-styles" #myForm="ngForm">
                <div class="form-group">
                    <div class="form-row">
                        <div class="col-md-6">
                            <label>Old Password <sup class="error">*</sup></label>
                            <input type="password" name="passwordOld" minlength="8"
                                data-toggle="tooltip" id="passwordOld" class="form-control input-md floatlabel" placeholder="Enter Old Password"
                                autofocus="on" autocomplete="off" maxlength="60" tabIndex="5" [(ngModel)]="old_pswd"/>
                            <!-- <div *ngIf="pswref.errors &&(pswref.touched || pswref.dirty)" class="alert alert-danger">
                                <div [hidden]="!pswref.errors?.pattern">
                                    One Capital, one Small , One Number , Min 8 Charecters
                                </div>
                            </div> -->
                        </div>
                        <div class="col-md-6">
                            <!-- <label for="last">Last Name</label>
                                                <input type="first" pattern="[a-zA-Z ]*" class="form-control" id="last" name="last" ngModel #lastref="ngModel"
                                                    [(ngModel)]="last_name">
                                                <div *ngIf="lastref.errors &&(lastref.touched || lastref.dirty)" class="alert alert-danger">
                                                    <div [hidden]="!lastref.errors?.pattern">
                                                        Please use Alphabets only
                                                    </div>
                                                </div> -->
                        </div>
                    </div>
                      <br>
                        <div class="form-group">
                          <div class="form-row">
                              <div class="col-md-6">
                                <label>New Password <sup class="error">*</sup></label>
                                <input type="password" name="password" pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$" minlength="8" data-toggle="tooltip" id="password"
                                  class="form-control input-md floatlabel" placeholder="Enter Password" autofocus="on" autocomplete="off"
                                  maxlength="60" tabIndex="5" [(ngModel)]="new_pswd" ngModel #pswref="ngModel" />
                                <div *ngIf="pswref.errors &&(pswref.touched || pswref.dirty)" class="alert alert-danger">
                                  <div [hidden]="!pswref.errors?.pattern">
                                    One Capital, one Small , One Number , Min 8 Charecters
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <label>Confirm Password <sup class="error">*</sup></label>
                                <input type="password" name="cpassword" pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$" id="cpassword" class="form-control input-md floatlabel"
                                  placeholder="Enter Confirm Password" autofocus="on" autocomplete="off" maxlength="60" tabIndex="6"
                                  [(ngModel)]="cnfPasw" ngModel #cnfref="ngModel" />
                                <div *ngIf="cnfref.errors &&(cnfref.touched || cnfref.dirty)" class="alert alert-danger">
                                  <div [hidden]="!cnfref.errors?.pattern">
                                    One Capital, one Small , One Number , Min 8 Charecters
                                  </div>
                                </div>
                              </div>
                          </div>
                      </div>
                      

                    <div class="row">
                        <div class="col-sm" style="height: 10px;"></div>
                        <div class="col-md" style="height: 30px"></div>
                      </div>

                    <div class="form-group">
                        <div class="form-row" style="float: right;">
                          <div class="col-md">
                            <input type="submit" name="submit" id="submit" class="btn btn-danger btn-block" tabIndex="9" value="Submit"
                              (click)="submit()">
                          </div>
                          <div class="col-md">
                            <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block" tabIndex="9" value="Reset"
                              (click)="reset()">
                          </div>
                        </div>
                      </div>
                </div>

                  
            </form>
    </div>
  </div>

</section> 